import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import BillingService from "../../../Services/BillingService";
import Preview from "../../../Assets/Icons/visibility.svg";
import {
  FaChevronLeft,
  FaChevronRight,
  FaFilter,
  FaRegEdit,
  FaSearch,
  FaVideo,
} from "react-icons/fa";
import Layouts from "../../Layouts";
import { Flex, Form, Input, message, Modal, Spin } from "antd";

import { MdKeyboardDoubleArrowUp } from "react-icons/md";
import PatientQueue from "../VCPage/PatientQueue";
import Draggable from "react-draggable";
import { IoIosCloseCircle } from "react-icons/io";
import patientqueue from "../../../Assets/Images/Svg/queue2.svg";
import nodatafound from "../../../Assets/Icons/NoDataCard2.svg";
import PatientService from "../../../Services/PatientService";
import UpArrow from "../../../Assets/Images/viewarrow.png";
import RPMPatientRegistration from "../Patients/AddNewPatient/index";
import { IoPersonAdd } from "react-icons/io5";
import { setSelectedRpmPatient } from "../../../Redux/actions/rpmActions";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { APP_ROUTES } from "../../../PageRouting/approutes";
import { setSelectedEditPatient } from "../../../Redux/actions/patientActions";
import PatientInvite from "./PatientInvite";

const Patients = () => {
  const storedLoginResult = sessionStorage.getItem("login_result");
  const loginResultObject = storedLoginResult
    ? JSON.parse(storedLoginResult)
    : null;

  const INITIAL_FILTERS = {
    pageNo: 1,
    account_Id: loginResultObject.user.account_Id,
  };
  const [filters, setFilters] = useState(INITIAL_FILTERS);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [hasSearchPerformed, setHasSearchPerformed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [hasNextPage, setHasNextPage] = useState(false);
  const ITEMS_PER_PAGE = 10;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isVerticalOpen, setIsVerticalOpen] = useState(true);
  const [formData, setFormData] = useState({
    patientName: "",
    patientId: "",
    email: "",
    mobile: "",
  });
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [saveModal, setSaveModal] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const [inviteModal, setInviteModal] = useState(false);
  const [inviteDetails, setInviteDetails] = useState({});

  useEffect(() => {
    dispatch(setSelectedEditPatient(null));
    sessionStorage.removeItem("rpmPatient");
  }, []);

  const saveModalClose = () => {
    setSaveModal(false);
    dispatch(setSelectedEditPatient(null));
    if (hasSearchPerformed) {
      fetchPatientsList();
    }
  };

  const handleSaveOk = () => {
    setSaveModal(true);
  };

  const showModal = () => setIsModalOpen(true);
  const handleOk = () => setIsModalOpen(false);
  const handleCancel = () => {
    setIsModalOpen(false);
    setFormData({ patientName: "", patientId: "", email: "", mobile: "" });
  };

  const fetchPatientsList = async () => {
    setLoading(true);
    try {
      const payload = { ...filters };
      const res = await PatientService.PatientListFilter(payload);
      setList(res.data);
      setHasNextPage(res.data.length == ITEMS_PER_PAGE);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!hasSearchPerformed) return;
    fetchPatientsList();
  }, [filters, hasSearchPerformed]);

  const applyFilter = (updatedValues) => {
    setFilters((prev) => ({ ...prev, ...updatedValues }));
    setIsFilterApplied(true);
    const searchKeys = ["patientName", "patientId", "email", "mobile", "rpmApplicable"];
    const hasSearchKey = Object.keys(updatedValues).some((k) => searchKeys.includes(k));
    if (hasSearchKey) setHasSearchPerformed(true);
  };

  const handlePageChange = (newPage) => {
    setFilters((prev) => ({ ...prev, pageNo: newPage }));
  };

  const clearFilters = () => {
    setFilters(INITIAL_FILTERS);
    setIsFilterApplied(false);
    setHasSearchPerformed(false);
    setList([]);
    setFormData({ patientName: "", patientId: "", email: "", mobile: "" });
  };

  useEffect(() => {
    setFilters((prev) => ({ ...prev }));
  }, []);

  const handleFinish = () => {
    const { patientId, patientName, email, mobile } = formData;
    if (!patientId && !patientName && !email && !mobile) {
      message.warning("Enter at least one value.");
      return;
    }
    applyFilter({ patientId, patientName, email, mobile });
    setIsModalOpen(false);
  };

  const handleShowRpmPatients = () => {
    applyFilter({ rpmApplicable: "Y", pageNo: 1 });
  };

  useEffect(() => {
    if (location.state?.filterRPM) {
      handleShowRpmPatients();
      history.replace(location.pathname, {});
    }
  }, [location.state]);

  const handleClick = () => setIsVerticalOpen(true);
  const closeCircle = () => setIsVerticalOpen(false);
  const onClose = () => setIsDrawerOpen(false);
  const showDrawer = () => setIsDrawerOpen(true);

  const handleEditPatient = (item) => {
    dispatch(setSelectedEditPatient(item));
    setSaveModal(true);
  };

  const handlePatientPallette = (item) => {
    sessionStorage.setItem("rpmPatient", JSON.stringify(item));
    sessionStorage.setItem("patient", JSON.stringify(item));
    dispatch(setSelectedRpmPatient(item));
    history.push(APP_ROUTES.RPMPATIENTPALLETTE);
  };

  const onSearch = (e) => {
    let value = e.target.value;
    if (value.length > 3) {
      applyFilter({ patientName: e.target.value });
    } else {
      setHasSearchPerformed(false);
      setList([]);
    }
  };

  const showInviteModal = (record) => {
    setInviteDetails(record);
    setInviteModal(true);
  };

  return (
    <Layouts>
      <div className="flex flex-col h-full">
        <div className="font-bold mb-3">Patients</div>

        {/* ══════════════════════════════════════════
            TOOLBAR
            Desktop: single row, all items inline (unchanged)
            Mobile:  row 1 = search full-width
                     row 2 = action buttons evenly spaced
        ══════════════════════════════════════════ */}

        {/* Mobile toolbar (hidden on md+) */}
        <div className="flex md:hidden flex-col gap-2 mb-2">
          {/* Row 1: Search full width */}
          <Input
            className="w-full"
            placeholder="Search Patient"
            onChange={(e) => onSearch(e)}
            suffix={
              <button className="bg-white font-semibold p-1 rounded-md">
                <FaSearch />
              </button>
            }
          />
          {/* Row 2: action buttons */}
          <div className="flex items-center gap-2">
            {isFilterApplied && (
              <button
                onClick={clearFilters}
                className="text-white bg-brand-primaryColor font-semibold px-3 py-2 rounded-md flex items-center text-xs flex-1 justify-center"
              >
                Clear
              </button>
            )}
            {loginResultObject.user.rpmApplicable === "Y" && (
              <button
                onClick={handleShowRpmPatients}
                className="text-white bg-brand-primaryColor font-semibold px-3 py-2 rounded-md text-xs flex-1 justify-center flex items-center"
              >
                RPM
              </button>
            )}
            <button
              className="text-white bg-brand-primaryColor font-semibold px-3 py-2 rounded-md flex items-center text-xs flex-1 justify-center"
              onClick={showModal}
            >
              <FaFilter className="mr-1" />
              Filter
            </button>
            <button
              className="text-white font-semibold p-2 bg-brand-primaryColor rounded-md flex items-center justify-center flex-1"
              onClick={handleSaveOk}
            >
              <IoPersonAdd className="w-4 h-4" />
            </button>
          </div>
        </div>

        {/* Desktop toolbar (hidden on mobile) — COMPLETELY UNCHANGED */}
        <div className="hidden md:flex gap-4">
          <div className="md:flex justify-end items-center md:w-[60%]">
            <Input
              className="md:w-[60%]"
              placeholder="Search Patient"
              onChange={(e) => onSearch(e)}
              suffix={
                <button className="bg-white font-semibold p-2 rounded-md">
                  <FaSearch />
                </button>
              }
            />
          </div>

          {isFilterApplied && (
            <button
              onClick={clearFilters}
              className="text-white bg-brand-primaryColor font-semibold p-2 rounded-md flex items-center"
            >
              Clear Filters
            </button>
          )}

          {loginResultObject.user.rpmApplicable === "Y" && (
            <button
              onClick={handleShowRpmPatients}
              className="text-white bg-brand-primaryColor font-semibold px-2 rounded-md"
            >
              RPM
            </button>
          )}

          <div className="flex items-center justify-end">
            <button
              className="text-white bg-brand-primaryColor font-semibold p-2 rounded-md flex items-center"
              onClick={showModal}
            >
              <FaFilter className="mr-1" />
              Filter
            </button>
          </div>

          <button
            className="text-white font-semibold p-2 bg-brand-primaryColor rounded-md"
            onClick={handleSaveOk}
          >
            <IoPersonAdd />
          </button>
        </div>

        {/* Table */}
        <div className="w-full mt-5 scrollwidth overflow-x-scroll rounded-md">
          {loading && (
            <div className="h-screen flex items-center justify-center">
              <Flex align="center" gap="middle">
                <Spin size="large" tip="Loading" />
              </Flex>
            </div>
          )}

          {!loading && !hasSearchPerformed && (
            <div className="flex flex-col items-center justify-center h-[500px]">
              <p className="font-medium text-xl">Search to view details</p>
            </div>
          )}

          {!loading && hasSearchPerformed && list.length === 0 && (
            <div className="flex flex-col items-center justify-center h-[500px]">
              <img src={nodatafound} alt="nodatafound" />
              <p className="font-medium text-xl">No Records found!!</p>
            </div>
          )}

          {!loading && list.length > 0 && (
            <div className="w-full overflow-x-auto overflow-y-hidden">
              <table className="w-full border border-gray-200 shadow-md rounded-md customTable mt-4">
                <thead className="bg-[#F5FEFA] text-[#333333] text-left text-sm font-sans font-medium">
                  <tr className="font-sans font-normal">
                    <th className="p-3 whitespace-nowrap">Patient ID</th>
                    <th className="p-3 whitespace-nowrap">Name</th>
                    <th className="p-3 whitespace-nowrap">Email ID</th>
                    <th className="p-3 whitespace-nowrap">Mobile</th>
                    <th className="p-3 whitespace-nowrap">Clinic Name</th>
                    <th className="p-3 whitespace-nowrap">Doctor Name</th>
                    <th className="p-3 whitespace-nowrap">Action</th>
                    {loginResultObject.user.rpmApplicable === "Y" && (
                      <th className="p-3 whitespace-nowrap">RPM</th>
                    )}
                    <th className="p-3 whitespace-nowrap">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {list?.map((record) => (
                    <tr
                      key={record.patientId}
                      className="border-t border-gray-200 hover:bg-gray-50 font-sans font-medium text-sm text-[#333333]"
                    >
                      <td className="p-3 whitespace-nowrap">{record.patientId}</td>
                      <td className="p-3 whitespace-nowrap">{`${record.patientName}`}</td>
                      <td className="p-3 whitespace-nowrap">{record.email}</td>
                      <td className="p-3 whitespace-nowrap">{record.mobile}</td>
                      <td className="p-3 whitespace-nowrap">{record.locationName}</td>
                      <td className="p-3 whitespace-nowrap">{record.userName}</td>
                      <td className="p-3 whitespace-nowrap">
                        <div className="flex gap-2">
                          <FaVideo
                            className="text-[#189FAA] text-xl"
                            onClick={() => showInviteModal(record)}
                            role="button"
                          />
                          <FaRegEdit
                            role="button"
                            className="cursor-pointer w-5 h-5 text-[#189FAA]"
                            onClick={() => handleEditPatient(record)}
                          />
                        </div>
                      </td>
                      {loginResultObject.user.rpmApplicable === "Y" && (
                        <td className="px-3 py-2 flex items-center justify-center">
                          <div className="flex items-center justify-center gap-2">
                            {record.rpmApplicable === "Y" ? (
                              <div onClick={() => handlePatientPallette(record)} title="Go to RPM">
                                <img
                                  src={UpArrow}
                                  alt="Navigate"
                                  className="w-7 h-7 p-1 rounded-full cursor-pointer shadow"
                                />
                              </div>
                            ) : (
                              <span>&nbsp;</span>
                            )}
                          </div>
                        </td>
                      )}
                      <td className="p-3 whitespace-nowrap">
                        <span
                          className={`${record.status === 1
                            ? "p-1 rounded font-semibold text-[#189FAA]"
                            : "p-1 text-red-600 rounded-md"
                            }`}
                        >
                          {record.status === 1 ? "Active" : "Inactive"}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {/* Pagination */}
        <div className="h-[49px] w-full border rounded-md flex justify-end items-center p-5">
          <div className="flex items-center justify-center space-x-2">
            <button
              className={`p-2 rounded-md ${filters.pageNo === 1
                ? "text-gray-400 cursor-not-allowed bg-white"
                : "text-gray-700 bg-white"
                }`}
              onClick={() => handlePageChange(filters.pageNo - 1)}
              disabled={filters.pageNo === 1}
            >
              <FaChevronLeft className="text-[#189FAA]" />
            </button>

            {filters.pageNo > 2 && (
              <>
                <button
                  className="px-3 py-1 text-gray-700 text-sm hover:bg-gray-200 bg-white border rounded-md"
                  onClick={() => handlePageChange(1)}
                >
                  1
                </button>
                {filters.pageNo > 3 && <span className="text-gray-500">...</span>}
              </>
            )}

            {filters.pageNo > 1 && (
              <button
                className="px-3 py-1 text-gray-700 text-sm hover:bg-gray-200 bg-white border rounded-md"
                onClick={() => handlePageChange(filters.pageNo - 1)}
              >
                {filters.pageNo - 1}
              </button>
            )}

            <button className="px-3 py-1 rounded-md bg-teal-500 text-white text-sm">
              {filters.pageNo}
            </button>

            {hasNextPage && (
              <button
                className="px-3 py-1 text-gray-700 text-sm hover:bg-gray-200 bg-white border rounded-md"
                onClick={() => handlePageChange(filters.pageNo + 1)}
              >
                {filters.pageNo + 1}
              </button>
            )}

            <button
              className={`p-2 rounded-md ${!hasNextPage
                ? "text-gray-400 cursor-not-allowed bg-white"
                : "text-gray-700 bg-white"
                }`}
              onClick={() => handlePageChange(filters.pageNo + 1)}
              disabled={!hasNextPage}
            >
              <FaChevronRight className="text-[#189FAA]" />
            </button>
          </div>
        </div>
      </div>

      {/* Filter Modal — unchanged */}
      <Modal
        wrapClassName="patients-filter-modal"
        title="Patients Filter"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[]}
        width={300}
      >
        <Form name="trigger" layout="vertical">
          <div className="flex flex-col gap-2 my-4">
            <div className="relative mt-4">
              <label htmlFor="patientName" className="absolute -top-3 z-10 left-2 bg-white px-1">
                Patient Name
              </label>
              <Input
                type="text" id="patientName" placeholder="" name="patientName"
                value={formData.patientName}
                onChange={(e) => setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }))}
              />
            </div>
            <div className="relative mt-4">
              <label htmlFor="patientId" className="absolute -top-3 z-10 left-2 bg-white px-1">
                Patient ID
              </label>
              <Input
                type="text" id="patientId" placeholder="" name="patientId"
                value={formData.patientId}
                onChange={(e) => setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }))}
              />
            </div>
            <div className="relative mt-4">
              <label htmlFor="email" className="absolute -top-3 z-10 left-2 bg-white px-1">
                Email ID
              </label>
              <Input
                type="text" id="email" name="email" placeholder=""
                value={formData.email}
                onChange={(e) => setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }))}
              />
            </div>
            <div className="relative mt-4">
              <label htmlFor="mobile" className="absolute -top-3 z-10 left-2 bg-white px-1">
                Mobile Number
              </label>
              <Input
                type="text" id="mobile" name="mobile" placeholder=""
                value={formData.mobile}
                onChange={(e) => setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }))}
              />
            </div>
          </div>
          <Form.Item>
            <div className="flex justify-end mt-3 border-brand-colorBorder gap-3 pt-2">
              <button
                className="h-[32px] Btnwhite rounded-md w-[82px] border-gray-600 border-2"
                onClick={handleCancel}
              >
                Cancel
              </button>
              <button
                className="h-[32px] w-[118px] text-white rounded-md"
                type="primary"
                onClick={() => handleFinish()}
              >
                Filter
              </button>
            </div>
          </Form.Item>
        </Form>
      </Modal>

      {/* New Patient Registration Modal — unchanged */}
      {saveModal && (
        <Modal
          wrapClassName="patients-reg-modal"
          title={<span className="text-base font-sans font-bold">New Patient Registration</span>}
          open={saveModal}
          onCancel={saveModalClose}
          footer={[]}
          width="60%"
          style={{ top: "0" }}
        >
          <RPMPatientRegistration handleCancel={saveModalClose} handleSave={saveModalClose} />
        </Modal>
      )}

      {/* Invite Patient Modal — unchanged */}
      <Modal
        wrapClassName="patients-invite-modal"
        title="Invite Patient"
        open={inviteModal}
        onOk={() => setInviteModal(false)}
        onCancel={() => setInviteModal(false)}
        footer={null}
        width={600}
        style={{ top: 20 }}
        maskClosable={false}
      >
        <PatientInvite inviteDetails={inviteDetails} handleInviteOk={() => setInviteModal(false)} />
      </Modal>

      {/* Patient Queue — unchanged */}
      <div>
        {isVerticalOpen ? (
          <Draggable>
            <div className="draggable-container fixed top-1/2 right-2 w-14 transform -translate-y-1/2 z-50">
              <div className="hidden md:block relative mb-5 cursor-pointer" onClick={closeCircle}>
                <IoIosCloseCircle className="hidden md:block absolute text-red-400 mb-1 right-0 top-0" />
              </div>
              <img
                src={patientqueue}
                alt="patientqueue"
                className="cursor-pointer"
                title="Patient Queue"
                onClick={showDrawer}
              />
            </div>
          </Draggable>
        ) : (
          <div className="vertical" style={{ marginTop: "16rem" }} onClick={handleClick}>
            <p className="vertical-p">
              <div className="vertical-icon-dashboard">
                <MdKeyboardDoubleArrowUp />
              </div>
              Queue
            </p>
          </div>
        )}
        {isDrawerOpen && (
          <div className="grid justify-end mt-5">
            {isDrawerOpen && <PatientQueue onClose={onClose} />}
          </div>
        )}
      </div>
    </Layouts>
  );
};

export default Patients;